import axios from './axios'
import qs from 'qs';

let baseUrl = '/api/purchaseOrder/';

export default {
  listPurchaseOrder(data) {
    return axios.post(baseUrl + 'listPurchaseOrder', qs.stringify(data));
  },
  countPurchaseOrder(data) {
    return axios.post(baseUrl + 'countPurchaseOrder', qs.stringify(data));
  },
  editConfirmStatus(data) {
    return axios.post(baseUrl + 'editConfirmStatus', qs.stringify(data));
  },
  editAsin(data) {
    return axios.post(baseUrl + 'editAsin', qs.stringify(data));
  },
  inBoundReconciliation(data) {
    return axios.post(baseUrl + 'inBoundReconciliation', qs.stringify(data));
  },
}
